export function hasInEscrowConsentRow(response) {
  const properties = response?.data?.properties;
  if (!Array.isArray(properties)) {
    return false;
  }
  return properties.some((row) => row?.kind === "in_escrow");
}
